import React from 'react';
import { GUIDE_SECTIONS, GUIDE_SOURCES } from './ownerGuideContent';

const TONES = {
  warn: 'border-amber-500/50 bg-amber-500/10 text-amber-100',
  info: 'border-sky-500/40 bg-sky-500/10 text-sky-100',
};

function Block({ block }) {
  switch (block.type) {
    case 'p':
      return <p className="text-sm leading-relaxed text-[#D1D5DB]">{block.text}</p>;
    case 'h':
      return <h4 className="pt-2 text-sm font-semibold text-[#E2B05E]">{block.text}</h4>;
    case 'ul':
      return (
        <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-[#D1D5DB]">
          {block.items.map((item) => <li key={item}>{item}</li>)}
        </ul>
      );
    case 'ol':
      return (
        <ol className="space-y-3 text-sm leading-relaxed text-[#D1D5DB]">
          {block.items.map((item, index) => (
            <li key={item} className="flex gap-3">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#E2B05E] text-xs font-semibold text-[#E2B05E]">{index + 1}</span>
              <span>{item}</span>
            </li>
          ))}
        </ol>
      );
    case 'callout':
      return <p className={`rounded-lg border px-4 py-3 text-sm leading-relaxed ${TONES[block.tone] || TONES.info}`}>{block.text}</p>;
    case 'table':
      return (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[420px] border-collapse text-sm">
            <thead>
              <tr>{block.head.map((cell) => <th key={cell} className="border border-[#242E42] bg-[#151B26] px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-[#9CA3AF]">{cell}</th>)}</tr>
            </thead>
            <tbody>
              {block.rows.map((row) => (
                <tr key={row.join('|')}>{row.map((cell) => <td key={cell} className="border border-[#242E42] px-3 py-2 align-top text-[#D1D5DB]">{cell}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    default:
      return null;
  }
}

export function OwnerGuide() {
  return (
    <div className="mx-auto max-w-4xl space-y-8" data-testid="owner-guide">
      <nav className="flex flex-wrap gap-2" aria-label="Secciones de la guía">
        {GUIDE_SECTIONS.map((section) => (
          <a key={section.id} href={`#guide-${section.id}`} className="rounded-full border border-[#242E42] px-3 py-1.5 text-xs text-[#9CA3AF] hover:border-[#E2B05E] hover:text-[#E2B05E]">{section.title}</a>
        ))}
      </nav>
      {GUIDE_SECTIONS.map((section) => (
        <section key={section.id} id={`guide-${section.id}`} className="scroll-mt-20 space-y-4 rounded-xl border border-[#242E42] bg-[#0F141D] p-5 sm:p-6">
          <h3 className="font-['Outfit'] text-xl font-semibold text-[#F3F4F6]">{section.title}</h3>
          {section.blocks.map((block, index) => <Block key={`${section.id}-${index}`} block={block} />)}
        </section>
      ))}
      <section className="rounded-xl border border-[#242E42] bg-[#0F141D] p-5 text-sm text-[#9CA3AF] sm:p-6">
        <h3 className="mb-2 font-['Outfit'] text-base font-semibold text-[#F3F4F6]">Fuentes oficiales</h3>
        <ul className="space-y-1">
          {GUIDE_SOURCES.map((source) => (
            <li key={source.url}><a href={source.url} target="_blank" rel="noopener noreferrer" className="text-[#3AB8D6] hover:underline">{source.label}</a></li>
          ))}
        </ul>
        <p className="mt-3 text-xs">Esta guía es orientativa y no sustituye la asesoría de tu contador. Las reglas pueden cambiar: verifica siempre en la DGI.</p>
      </section>
    </div>
  );
}
